import Navbar from "../../NavBar/Navbar"
import SideBar from "../../NavBar/Sidebar"
import ConsultaGuiaContent from "./ConsultaGuiaContent"

interface ChildsProps {
    logout: () => void
}


const ConsultaGuia: React.FC<ChildsProps> = ({logout}) => {
    return(
    <div className="sidebar-noneoverflow">
        <Navbar logout={logout}/>
    
        <div className="main-container" id="container">
            <SideBar/>
            
            <ConsultaGuiaContent/>
        </div>

    </div>
    )
}


export default ConsultaGuia